module.exports = __webpack_public_path__ + "static/media/claim-with-js-tool.11a5263e.png";